import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import styled from 'styled-components';

export const ContentFrameIframe = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border: none;
`;

export const ContentFrameVideo = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border: none;
`;

export const ContentFrameNextButton = styled(AppButton)`
  position: absolute;
  right: -48px;
  top: 50%;
`;

export const PreviewAspectRatioFrame = styled.div`
  position: relative;
  display: flex;
  margin: auto;
  width: 70%;
  max-width: 1000px;
  aspect-ratio: 16 / 9;
`;

export const LearnerAspectRatioFrame = styled.div`
  position: relative;
  display: flex;
  margin: auto;
  width: 70%;
  max-width: 1000px;

  &.mobile {
    position: static;
  }

  &::before {
    content: '';
    width: 0;
    padding-bottom: 56.25%;
    display: block;
  }

  @media screen and (max-width: 767px) {
    & {
      width: 100%;
    }
  }
`;

export const ContentGrayPanel = styled(FlexContainer)`
  border: 1px solid var(--gray-dark);
  border-radius: var(--xsmall-border-radius);
  background-color: var(--beige-main);
  padding: var(--default-padding);
`;
